// draggableNode.js

export const DraggableNode = ({ type, label }) => {
  const onDragStart = (event, nodeType) => {
    const appData = { nodeType }
    event.target.style.cursor = 'grabbing';
    event.dataTransfer.setData('application/reactflow', JSON.stringify(appData));
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      onDragStart={(event) => onDragStart(event, type)}
      onDragEnd={(event) => (event.target.style.cursor = 'grab')}
      className={`
        ${type} cursor-grab 
        px-4 py-2 rounded-pill
        bg-white/5 border border-white/10
        hover:border-pipeline-accent/50 hover:bg-pipeline-accent/10
        transition-all duration-300 active:scale-95 active:cursor-grabbing
        group flex items-center gap-2 whitespace-nowrap
      `}
      draggable
    >
      <div className="w-1.5 h-1.5 rounded-full bg-pipeline-secondary opacity-50 group-hover:opacity-100 group-hover:shadow-[0_0_8px_#0070FF] transition-all" />
      <span className="text-xs font-semibold text-white/70 group-hover:text-white transition-colors">
        {label}
      </span>
    </div>
  );
};
